import request from '@/utils/request'


// 流式调用，需要传 onProgress 和 onDone 两个回调
export async function batchCompleteDispatchStream(data, { onProgress, onDone, onError }) {
  // 从 store 或 cookie 拿 token
  const token = sessionStorage.getItem('token') || 
                document.cookie.match(/vue_admin_template_token=([^;]+)/)?.[1]?.replace('Bearer%20', 'Bearer ')

  try {
    const resp = await fetch(
      // 这里的 url 要和你 axios baseURL 拼起来一致
      process.env.VUE_APP_BASE_API + '/dispatcher/batchCompleteDispatchStream',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': decodeURIComponent(token || '')
        },
        body: JSON.stringify(data)
      }
    )

    if (!resp.ok) {
      throw new Error('HTTP ' + resp.status)
    }

    const reader = resp.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let buffer = ''

    // eslint-disable-next-line no-constant-condition
    while (true) {
      const { value, done } = await reader.read()
      if (done) break
      buffer += decoder.decode(value, { stream: true })

      // 按行拆分（后端用 \n 分隔的 ndjson）
      let nlIdx
      while ((nlIdx = buffer.indexOf('\n')) >= 0) {
        const line = buffer.slice(0, nlIdx).trim()
        buffer = buffer.slice(nlIdx + 1)
        if (!line) continue
        try {
          const event = JSON.parse(line)
          if (event.type === 'done') {
            onDone && onDone(event)
          } else {
            onProgress && onProgress(event)
          }
        } catch (e) {
          console.warn('解析失败的行:', line)
        }
      }
    }
  } catch (err) {
    onError && onError(err)
  }
}


export function listWriterPendingDispatches(params) {
  return request({
    url: '/dispatcher/listWriterPendingDispatches',
    method: 'get',
    params
  })
}

export function batchCompleteDispatch(data) {
  return request({
    url: '/dispatcher/batchCompleteDispatch',
    method: 'post',
    data
  })
}

export function worktopTaskNeededDispatch(param) {
  return request({
    url: '/dispatcher/worktop/task-needed-dispatch',
    method: 'get',
    params: param
  })
}

export function worktopDispatchNeededComment(param) {
  return request({
    url: '/dispatcher/worktop/dispatch-needed-comment',
    method: 'get',
    params: param
  })
}

export function worktopDispatchNeededSettlement(param) {
  return request({
    url: '/dispatcher/worktop/dispatch-needed-settlement',
    method: 'get',
    params: param
  })
}

export function worktopSettlementNeededRecall(param) {
  return request({
    url: '/dispatcher/worktop/settlement-needed-recall',
    method: 'get',
    params: param
  })
}

export function worktopTenDayTask(param) {
  return request({
    url: '/dispatcher/worktop/ten-day-task',
    method: 'get',
    params: param
  })
}

export function worktopNextDayTask(param) {
  return request({
    url: '/dispatcher/worktop/next-day-task',
    method: 'get',
    params: param
  })
}

export function setUrgentStatus(data){
  return request({
    url: '/dispatcher/seturgentstatus',
    method: 'post',
    data: data
  })
}


export function worktop(param){
  return request({
    url: '/dispatcher/worktop',
    method: 'get',
    params: param
  })
}

export function getMyWriterSettlement(param){
  return request({
    url: '/dispatcher/getmywritersettlement',
    method: 'get',
    params: param
  })
}




export function dispatcherSearch(param){
  return request({
    url: '/dispatcher/dispatchersearch',
    method: 'get',
    params: param
  })
}


export function newWriterSettlement(param){
  return request({
    url: '/dispatcher/newwritersettlement',
    method: 'get',
    params: param
  })
}

export function updataDispatchRefunds(data) {
  return request({
    url: '/dispatcher/updatadispatcherrefunds',
    method: 'get',
    params: data
  })
}
export function getDispatchRefunds(data) {
  return request({
    url: '/dispatcher/getdispatcherrefunds',
    method: 'get',
    data: data
  })
}

export function updateDispatchComment(data) {
  return request({
    url: '/dispatcher/updatedispatchcomment',
    method: 'post',
    data: data
  })
}

export function editDispatch(param) {
  return request({
    url: '/dispatcher/editdispatch',
    method: 'get',
    params: param
  })
}

export function updateDispatch(param) {
  return request({
    url: '/dispatcher/updatadispatch',
    method: 'post',
    params: param
  })
}

export function gatDispatcherInfo(param) {
  return request({
    url: '/dispatcher/getdispatcherinfo',
    method: 'get',
    params: param
  })
}
